import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';

const TextGroup = ({ className, ...otherProps }) => (jsx("div", { ...otherProps, className: classNames(className, style['z-product-price__text-group']) }));
TextGroup.displayName = 'TextGroup';

export { TextGroup };
//# sourceMappingURL=TextGroup.js.map
